import axios from "axios";
import {server} from "@/variables";

function getFullClientsChunk(limit, offset) {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.get(`${server}/users?limit=${limit}&offset=${offset}`, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}

function getListenersChunk(limit, offset) {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.get(`${server}/listeners?limit=${limit}&offset=${offset}`, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}

function getRegionListeners(regionIds) {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.get(`${server}/listeners?regions=${regionIds.join(';')}`, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}

function getManagerListeners(managerIds) {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.get(`${server}/listeners?managers=${managerIds.join(';')}`, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}

function getListenersWithOrders() {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.get(`${server}/listeners?withOrder=1`, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}

function getVolumesList() {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.get(`${server}/list/volumes`, {headers: {'admin-token': token}})
            .then((data) => {
                resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}

function getVolumeListeners(volumes) {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.get(`${server}/listeners?volumes=${volumes.join(';')}`, {headers: {'admin-token': token}})
            .then((data) => {
                resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}

function editClient(clientId, bonuses, discount) {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.post(`${server}/user`, {clientId, bonuses, discount }, {headers: {'admin-token': token}})
            .then((data) => {
                resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    });
}

function getAllClients() {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.get(`${server}/listeners?all=1`, {headers: {'admin-token': token}})
            .then((data) => {
                resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    });
}

export {
    getFullClientsChunk,
    getListenersChunk,
    getRegionListeners,
    getManagerListeners,
    getListenersWithOrders,
    getVolumesList,
    getVolumeListeners,
    editClient,
    getAllClients
}